import styled from 'styled-components';
import { IconName } from '@optimus-web/icons';
import { Icon } from '../../Icon';

export const ErrorIcon = styled(Icon).attrs({
    size: 'small',
    value: IconName.ErrorCircle,
    variant: 'danger',
})`
    align-self: center;
`;
